module.exports = __webpack_public_path__ + "img/img_sub_comp_vision02.e34df9ae.svg";